import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00e34029"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "flex items-center justify-between px-6 py-4 border-b border-capGrey border-opacity-30 flex-shrink-0" }
const _hoisted_3 = { class: "text-lg font-semibold text-capDarkPurple" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "flex-1 overflow-auto p-6" }




export default /*#__PURE__*/_defineComponent({
  __name: 'CDialog',
  props: {
    modelValue: { type: Boolean, required: true },
    title: { type: String, default: '' },
    width: { type: String, default: '42rem' },
    height: { type: String, default: 'auto' },
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {





function close() {
    emit('update:modelValue', false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "dialog-overlay" }, {
      default: _withCtx(() => [
        (__props.modelValue)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 bg-black bg-opacity-50 z-40",
              onClick: close,
              "aria-hidden": "true"
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "dialog-panel" }, {
      default: _withCtx(() => [
        (__props.modelValue)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              role: "dialog",
              "aria-modal": "true",
              "aria-label": __props.title,
              class: "fixed inset-0 z-50 flex items-center justify-center p-4"
            }, [
              _createElementVNode("div", {
                class: "bg-white shadow-xl rounded-lg flex flex-col",
                style: _normalizeStyle({ width: __props.width, height: __props.height, maxWidth: 'calc(100vw - 2rem)', maxHeight: 'calc(100vh - 2rem)' })
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("h2", _hoisted_3, _toDisplayString(__props.title), 1),
                  _createElementVNode("button", {
                    type: "button",
                    class: "text-capGrey hover:text-capDarkPurple transition-colors p-1 rounded",
                    onClick: close,
                    "aria-label": "Close"
                  }, _hoisted_5)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _renderSlot(_ctx.$slots, "default")
                ])
              ], 4)
            ], 8, _hoisted_1))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})